<template>
    <div>
        <el-button type="success" plain icon="el-icon-setting" size="mini" @click="pluginDownload">下载插件</el-button>
        <h3>一、下载exe文件</h3>
        <div>1.打开exe文件：</div>
        <div style="color: red;">点击按钮：<img src="../assets/images/1.png" alt=""></div>
        <div style="color: red;">打开文件夹：
            <el-card class="box-card" style="display:flex; background-color: aliceblue;width: 80%;">
                <img style="width: 100%;" src="../assets/images/2.png" alt="">
                <img style="width: 20%;" src="../assets/images/3-1.png" alt="">
            </el-card>
        </div>
        <h1 style="color: red;">请拔出u盘再运行exe文件！！！！</h1>
        <h3>二、运行exe文件：</h3>
            <div>1.双击<img src="../assets/images/3.png" alt=""></div>
            <div>
            2.解除限制：
            <el-card class="box-card" style="background-color: aliceblue;width: 50%;">
                <img style="width: 450px;" src="../assets/images/4.png" alt=""></img>
                <img style="width: 450px;" src="../assets/images/5.png" alt=""></img>
            </el-card>
               
            </div>
        <h3>
            三、输入名字和部门：
            <el-card class="box-card" style="background-color: aliceblue;width: 80%;">
                <h1 style="color: red;">请拔出u盘再运行</h1>
                <span>1.确认</span>
                <img style="width: 450px;" src="../assets/images/6.png" alt=""></img>
                <span>2.输入</span>
                <img style="width: 800px;" src="../assets/images/7.png" alt=""></img>
            </el-card>
        </h3>

    </div>
</template>

<script>
// import { getServerInfo } from '../mixins/getCpu.js';
export default {
    name: 'getComputInformation',
    data() {
        return {

        }
    },
    created() {
        // const os = require('os-utils');
        // os.cpuUsage(function (v) {
        // });


    },
    methods: {
        pluginDownload() {
            window.location.href = "/2024年终资产盘点.exe";
        },

    },
}
</script>

<style lang="css" scoped>
*{
    padding: 0;
    margin: 0;
}
.el-button{
    padding: 10px;
}
.img{
    width: 100%;
}
</style>